import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import {useFormikContext} from "formik";

import FormikInput from "components/input/new/FormikInput";
import {ListContext} from "components/List/context/ListContext";

import {greyishBlue500} from "assets/jss/main";

function DefaultReturnMethodField(props) {
    const {values} = useFormikContext();
    const {selectedItem, notFilteredListItems} = useContext(ListContext);

    // only one method per eshop can hold the flag: the API clears it on the others when this one
    // is saved, so the method it is about to replace is named here.
    const replacedMethod = notFilteredListItems.find(shippingMethod => (
        shippingMethod.isDefaultReturnMethod && shippingMethod.id !== selectedItem?.id
    ));

    return (
        <>
            <FormikInput
                type={'checkbox'}
                name={'isDefaultReturnMethod'}
                label={'shippingMethods.form.field.isDefaultReturnMethod.label'}
                noPadding={true}
            />
            {values.isDefaultReturnMethod && replacedMethod && (
                <span style={{fontSize: '12px', color: greyishBlue500}}>
                    <FormattedMessage
                        id={'shippingMethods.form.field.isDefaultReturnMethod.replace'}
                        values={{name: replacedMethod.name || replacedMethod.shopName}}
                    />
                </span>
            )}
        </>
    );
}

export default DefaultReturnMethodField;
